import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'
import { IPayload } from '@network/models/global.model'
import {
  IMagicLink,
  IPostMagicLinkParams,
} from '@network/models/magic-link.model'

export class MagicLinkApi {
  constructor(private axios: AxiosService) {}

  postMagicLink = async (params: IPostMagicLinkParams) => {
    const response = await this.axios.post<IPayload<IMagicLink>>(
      Endpoints.postMagicLink,
      params,
    )
    return response
  }
}
